import axios from 'axios'
import * as Cookies from 'js-cookie';
import {MessageBox} from 'element-ui';
export const baseURL = 'https://api.ruanmeihui.net/api/'
export default function install(Vue, router) {

    Object.defineProperty(Vue.prototype, '$http', {
        get() {

            let $router = router.currentRoute;
            /**
             * Create Axios
             */
            var http = axios.create({
                baseURL: baseURL,
                withCredentials: true
            })

            http.defaults.headers.common = {
                "x-identity": 'advertiser'
                //"Content-Type": "application/json;charset=UTF-8",
                //Accept: 'application/json',
                //Authorization: Cookies.get('_token')
            };

            http
                .interceptors
                .response
                .use((response) => {
                    return response.data;
                }, (error) => {
                    const {
                        response
                    } = error

                    switch (response.status) {
                        case 401:
                            if($router.meta.verify)
                            {
                                window.location.href = "/login?url_callback=" + encodeURI(document.URL)
                            }else
                            {
                                return response.data
                            }
                            break;
                        case 403:
                            window.location.href = "/login?url_callback=" + encodeURI(document.URL)
                            break;
                        case 404:
                            MessageBox.confirm('你所访问的内容或者页面不存在', '404', {
                                closeOnClickModal: false,
                                closeOnPressEscape: false,
                                showClose: false,
                                cancelButtonText: '返回首页',
                                confirmButtonText: '返回上一页',
                                type: 'error',
                                callback: (action) => {
                                    if (action === 'confirm') {
                                        return window
                                            .history
                                            .back(-1)
                                    } else {
                                        return window.location.href = "/"
                                    }
                                }
                            })
                        default:
                            return response.data

                    }
                });

            return http
        }
    })
}



// WEBPACK FOOTER //
// ./src/plugins/http/index.js